import setDisabledStatus from './set-disabled-status';

export default {
  setDisabledStatus,
};
